import type * as types from "./types";

import {
  type DocumentNode,
  type MutationTuple,
  type OperationVariables,
  type TypedDocumentNode,
  useMutation,
} from "@apollo/client";
import Bugsnag from "@bugsnag/browser";

import { useClient } from "./use-client";

export function useNorthbeamMutation<T, V = OperationVariables>(
  mutation: DocumentNode | TypedDocumentNode<T, V>,
  options?: types.MutationOptions<T, V>,
): MutationTuple<T, V> {
  const client = useClient(options);

  const [caller, result] = useMutation<T, V>(mutation, {
    ...options,
    client,
  });

  if (result.error && !options?.doNotRaiseErrorOnFailure) {
    Bugsnag.setContext(
      `GraphQL mutation failure. \nMutation: ${JSON.stringify(
        mutation,
      )}\nOptions: ${JSON.stringify(options)}`,
    );
    throw result.error;
  }

  return [caller, result];
}
